import { createFileRoute } from '@tanstack/react-router';

import { Feedback } from '#features/feedback/components/Feedback';
import { ReCaptchaProvider } from '#features/form';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/feedback')({
  component: RouteComponent,
  ssr: false,
});

// Капчу просит форма обращения в поддержку.
function RouteComponent() {
  return (
    <ReCaptchaProvider>
      <Feedback />
    </ReCaptchaProvider>
  );
}
